export const SECTION_LABELS = {
  to_respond: 'Aguardando sua resposta',
  to_approve: 'Para você aprovar',
}

export const PRIORITIES = {
  urgent: { key: 'urgent', label: 'Urgente', rank: 0 },
  high: { key: 'high', label: 'Alta', rank: 1 },
  normal: { key: 'normal', label: 'Normal', rank: 2 },
  low: { key: 'low', label: 'Baixa', rank: 3 },
}

export const ITEM_CONFIG = {
  swap: {
    title: 'Troca de plantão',
    path: '/WorkSchedulesSwap',
    peer: { subtitle: 'Um colega pediu troca com você', priority: 'urgent', query: { tab: 'received' } },
    approver: { subtitle: 'Trocas aguardando sua aprovação', priority: 'high', query: { tab: 'approvals' } },
  },
  swap_cancellation: {
    title: 'Cancelamento de troca',
    path: '/WorkSchedulesSwapCancellation',
    peer: { subtitle: 'Um colega pediu para cancelar uma troca com você', priority: 'urgent', query: { tab: 'received' } },
    approver: { subtitle: 'Cancelamentos aguardando sua aprovação', priority: 'high', query: { tab: 'approvals' } },
  },
  check_request: {
    title: 'Marcação de ponto',
    path: '/checkRequests/approve',
    approver: { subtitle: 'Marcações manuais para aprovar', priority: 'high' },
  },
  check_adjustment: {
    title: 'Ajuste de ponto',
    path: '/check-adjustment-requests/approve',
    approver: { subtitle: 'Ajustes de marcação para aprovar', priority: 'high' },
  },
  release: {
    title: 'Liberação de escala',
    path: '/workschedule',
    approver: { subtitle: 'Liberações de escala para aprovar', priority: 'normal' },
  },
}

export function sortRows(rows) {
  return rows.slice().sort((a, b) => (a.priority.rank - b.priority.rank) || (b.count - a.count))
}

export function buildRows(items, role) {
  const rows = []
  const list = items || []
  list.forEach(item => {
    const config = ITEM_CONFIG[item && item.type]
    const roleConfig = config && config[role]
    const count = Number(item && item.count)
    if (!roleConfig || !(count > 0)) return
    rows.push({
      type: item.type,
      role,
      count,
      title: config.title,
      subtitle: roleConfig.subtitle,
      priority: PRIORITIES[roleConfig.priority],
      to: { path: config.path, query: roleConfig.query || {} },
    })
  })
  return sortRows(rows)
}
